module.exports = __webpack_public_path__ + "img/coins-3.56f0713a.png";